import Model from '../Apis/Announcements'
import Controller from './Controller'

export default class AnnouncementsController extends Controller {
  constructor() {
    super(new Model())
  }
}
